import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHeaderContext } from '~/components/layout/Header/HeaderContext';
import { cn } from '~/helpers/utils';
import type { DropdownMenu, MenuSlug } from '~/types/navigation';

type NavigationDropdownMenuProps = {
  slug: MenuSlug;
  links: DropdownMenu;
};

const NavigationDropdownMenu = ({
  slug,
  links,
}: NavigationDropdownMenuProps) => {
  const { openMenu, onMenuEnter, onMenuLeave } = useHeaderContext();
  const isOpen: boolean = openMenu === slug;

  const linkClasses = cn(
    'flex items-center gap-2 py-2 text-sm font-medium no-underline transition-colors',
    'text-blue-800 hover:text-blue-600',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500'
  );

  return (
    <div
      className={cn(
        'absolute left-0 top-full z-50 min-w-48',
        'rounded-b-lg border-stone-200 bg-white transition-all duration-300',
        isOpen && 'border-t shadow-xl'
      )}
    >
      <div
        className={cn(
          'relative grid overflow-hidden transition-all duration-300',
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        )}
        aria-hidden={!isOpen}
        onMouseEnter={onMenuEnter}
        onMouseLeave={onMenuLeave}
      >
        <div className="min-h-0">
          <div
            className={cn(
              'relative p-6 transition-all duration-500',
              isOpen ? 'translate-y-0 opacity-100' : 'translate-y-25 opacity-0'
            )}
          >
            {links.map((link) => (
              <a
                key={`dropdown-menu-link-${link.href}`}
                href={link.href}
                className={linkClasses}
              >
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="text-blue-500"
                />
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationDropdownMenu;
